export default {
    smartSearch: {
        errorsTipNum: '{num} 處錯誤',
        errorCode: {
            10001: '字段名稱錯誤',
            10002: '不能嵌套檢索字段，該字段名稱被當做文本識別',
            10003: '該命令只能在ANS/ANCS/ALL_AN字段下使用',
            10004: '語法錯誤',
            20001: '不能以邏輯詞開頭',
            20002: '不能連續出現多個邏輯詞',
            20003: '不能以邏輯詞結尾',
            20004: '邏輯運算符個數超過1024個',
            30001: '字段值為空',
            30002: '缺少符號:)',
            30003: '多余符號:)',
            30004: '缺少符號:]',
            30005: '多余符號:]',
            30006: '缺少符號:"',
            30007: "缺少符號:'",
            30008: '缺少符號:|',
            40001: '位置符格式錯誤',
            40002: '頻率運算符格式錯誤',
            40003: '位置符個數超過15個',
            40004: 'n最大值為50',
            40005: '語法錯誤',
            50001: '字段值錯誤',
            50002: '該字段僅能輸入日期(YYYY or YYYYMM or YYYYMMDD)',
            50003: '結束日期不能早於開始日期',
            50004: '該字段僅能輸入正整數',
            50005: '數字格式未從小到大',
            60001: '檢索式格式錯誤',
            70001: '該特殊檢索式格式錯誤',
            70002: '同一個搜索語句只能包含一個特殊檢索式',
            70003: '特殊檢索式的位置只能在檢索式開頭',
            70004: '請將文件夾路徑放在||內',
            70005: '請將層級字段、選項字段的標引值放在""內',
            70006: '請將not blank放在""內',
            80001: 'R命令只能使用AND連接',
            80002: '檢索語句中只能出現一個R命令',
            80003: 'R命令的位置只能在檢索式的開頭。',
        },
        nodata: '無數據',
    },
};
